// extracted by mini-css-extract-plugin
export var fadeIn = "_l0-1";
export var modalContent = "_l0-3";
export var overlay = "_l0-0";
export var popoverContent = "_l0-2";
export var results = "_l0-5";
export var searchInputWrapper = "_l0-4";